import type { LoaderFunction } from 'react-router'
import type { CreateNotificationsRoutesOptions } from './routes'

/**
 * Creates a loader function for the notifications page that loads the
 * route's job into the pane and selects it in the list.
 *
 * @param options
 */
export function createNotificationsViewLoader(
  options: CreateNotificationsRoutesOptions,
): LoaderFunction {
  return async (args) => {
    const data: unknown = await options.jobPaneLoader(args)
    const { notificationsPageVm } = await options.notifications.internal()
    // A superseded navigation must not select its job over the newer one.
    args.request.signal.throwIfAborted()
    notificationsPageVm.selectJob(args.params.jobId ?? null)
    return data
  }
}
